import { useQuery } from 'react-query'

import type { TrendDetectionService } from 'features/trend-detection/service/service'
import type { BenchmarkingAgentRun } from 'features/trend-detection/types'

export interface UseBenchmarkingAgentRunsResult {
  runs: BenchmarkingAgentRun[]
  isLoading: boolean
  isError: boolean
}

/**
 * Lives alongside the issue-agent detail page's `use-agent-runs` because both
 * consumers of the reskinned activity feed pattern (issue-agent detail and
 * benchmarking-agent detail) reuse the same slice-2 primitives. Not a
 * cross-feature leak — the file is exposed via the feature-root seam at
 * `issue-agent-detail/index.ts` so external callers import it there.
 */
export function useBenchmarkingAgentRuns(
  service: TrendDetectionService,
  projectId: string | null,
  agentUuid: string | null,
): UseBenchmarkingAgentRunsResult {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['benchmarking-agent-runs', projectId, agentUuid],
    queryFn: async () => {
      if (!projectId || !agentUuid) throw new Error('missing')
      return service.fetchBenchmarkingAgentRuns(projectId, agentUuid)
    },
    enabled: !!projectId && !!agentUuid,
  })
  return {
    runs: data ?? [],
    isLoading,
    isError,
  }
}
